export default __webpack_public_path__ + "static/media/credit_icon_unlocked.ac265eb2.png";